import colors from '../../_shared/colors';

export default {
  container: `
    display: flex;
    flex-direction: column;
    flex: 1;
    width: 100%;
    padding: 16px;
  `,
  titleRow: `
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-bottom: 16px;
  `,
  title: `
    font-size: 32px;
    font-weight: 700;
    text-align: center;
    margin: 0;
    line-height: 1.2;
  `,
  refreshBtn: `
    position: absolute;
    right: 0;
  `,
  header: `
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 12px;
    flex-wrap: wrap;
  `,
  headerLeft: `
    display: flex;
    align-items: center;
    gap: 16px;
    min-width: 0;
  `,
  headerRight: `
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
  `,
  logoImg: `
    max-height: 110px;
    max-width: 320px;
    object-fit: contain;
  `,
  dba: `
    font-size: 22px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    line-height: 1.2;
  `,
  licenseSelect: `
    min-width: 240px;
    max-width: 360px;
  `,
  headerActions: `
    display: flex;
    gap: 8px;
  `,
  exportBtn: `
    background-color: ${colors.highlight};
    color: white;
    border-color: ${colors.highlight};
    &:hover, &:focus {
      background-color: ${colors.highlight};
      color: white;
      opacity: 0.9;
      border-color: ${colors.highlight};
    }
  `,
  kpiRow: `
    margin-bottom: 20px;
  `,
  kpiCard: `
    text-align: center;
    height: 100%;
    .ant-card-body {
      padding: 16px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  `,
  kpiLabel: `
    font-size: 13px;
    color: rgba(0, 0, 0, 0.55);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 8px;
    min-height: 2.6em;
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  kpiValue: `
    font-size: 28px;
    font-weight: 700;
    line-height: 1;
  `,
  section: `
    margin-bottom: 20px;
  `,
  sectionTitle: `
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 12px;
  `,
  chartWrap: `
    width: 100%;
    height: 280px;
  `,
  chartScroll: `
    width: 100%;
    height: 280px;
    overflow-x: auto;
    overflow-y: hidden;
  `,
  chartInner: `
    height: 100%;
    min-width: 100%;
  `,
  orderLink: `
    color: ${colors.highlight};
    cursor: pointer;
    font-weight: 500;
    &:hover {
      color: ${colors.highlight};
      text-decoration: underline;
      opacity: 0.85;
    }
  `,
  // Keep the License # column on one line on desktop (Danielle 2026-06-03);
  // allow wrapping below the antd md breakpoint (mobile), matching the
  // surrounding Col xs={24} md={12} layout.
  licenseNoWrap: `
    td.license-col, th.license-col {
      white-space: nowrap;
    }
    @media (max-width: 767px) {
      td.license-col, th.license-col {
        white-space: normal;
      }
    }
  `,
};
